import React from 'react';
import classnames from 'classnames';
import { gikClassPrefix } from '@gik/core/constants';

export interface IBackgroundImageProps extends React.HTMLAttributes<HTMLElement> {
  /**
   * url to image
   * This is optional because the url to the image could be fetched from the backend.
   * TODO: In that case this component should display itself in a loading state.
   */
  src?: string;
}

const blockName = `${gikClassPrefix}-bg-image`;

/**
 * This component displays an image as a css background
 */
function BackgroundImage({ children, src, className, ...otherProps }: IBackgroundImageProps): React.ReactElement {
  const blockClasses = classnames([blockName, className || '']);

  const style = src
    ? {
        backgroundImage: `url(${src})`,
      }
    : {};

  return (
    <div className={blockClasses} style={style} {...otherProps}>
      {children}
    </div>
  );
}

// only re-render image if the src changed
export default React.memo(BackgroundImage, (prevProps, nextProps) => {
  return prevProps.src === nextProps.src;
});
